import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "books__text-box" }
const _hoisted_2 = { class: "books__text" }
const _hoisted_3 = { class: "books__upper-box" }
const _hoisted_4 = { class: "books__title card__title" }
const _hoisted_5 = { class: "books__author card__author" }
const _hoisted_6 = { class: "books__lower-box" }

import { computed } from 'vue'

import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'
import LazyImage from '@/app/components/podcast/card/LazyImage.vue'
import DocBadges from '@/app/components/doc/DocBadges.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'
import DocProgressBar from '@/app/components/doc/DocProgressBar.vue'
import DocTypeBadge from '@/app/components/doc/DocTypeBadge.vue'
import SaveButton from '@/app/components/doc/SaveButton.vue'

import type { DocListItem, CustomList } from '@/models/interfaces'
import type { DocsView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'AnyDocCard20321',
  props: {
    doc: {},
    view: {},
    customList: {},
    showFreeBooks: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const hasProgress = computed(() => {
  return props.doc.doc_type !== 'article'
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["books__item", [`books__item_${__props.doc.doc_type}`, __props.doc.id]])
  }, [
    (__props.view.hasUserData(__props.doc))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(SaveButton, {
            class: "books__save-button",
            doc: __props.doc,
            docsView: __props.view
          }, null, 8, ["doc", "docsView"]),
          _createVNode(DocMoreMenu, {
            class: _normalizeClass(["books__more-menu", {
          'books__more-menu--above-progress': hasProgress.value && __props.doc.user?.progress,
        }]),
            doc: __props.doc,
            docsView: __props.view
          }, null, 8, ["class", "doc", "docsView"])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_router_link, {
      to: __props.view.startLinkParams(__props.doc),
      class: "books__link"
    }, {
      default: _withCtx(() => [
        _createVNode(DocTypeBadge, {
          docType: __props.doc.doc_type
        }, null, 8, ["docType"]),
        (__props.doc.doc_type === 'book')
          ? (_openBlock(), _createBlock(BookCardThumbnail, {
              key: 0,
              class: "books__img-box",
              coverClass: "books__img",
              fallbackCoverClass: "books__img",
              doc: __props.doc,
              cacheBust: true
            }, null, 8, ["doc"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["books__fit_img-box", {
          'books__fit_img-box--circle': __props.doc.doc_type === 'podcast_episode',
        }])
            }, [
              _createVNode(LazyImage, {
                src: __props.doc.cover_image,
                crossorigin: "anonymous",
                class: "books__fit_img",
                alt: ""
              }, null, 8, ["src"])
            ], 2)),
        (hasProgress.value)
          ? (_openBlock(), _createBlock(DocProgressBar, {
              key: 2,
              class: "books__progress",
              progress: __props.doc.user?.progress
            }, null, 8, ["progress"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.doc.title), 1),
              _createElementVNode("h4", _hoisted_5, _toDisplayString(__props.doc.author), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(DocBadges, {
                doc: __props.doc,
                free: __props.showFreeBooks && __props.doc.is_free
              }, null, 8, ["doc", "free"]),
              (hasProgress.value && __props.doc.user?.progress)
                ? (_openBlock(), _createBlock(DocProgressBar, {
                    key: 0,
                    class: "books__progress--mobile",
                    progress: __props.doc.user.progress
                  }, null, 8, ["progress"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}
}

})